import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Crown, Sparkles, AlertCircle, Activity, Radio } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Modale premium d'upsell affichée aux comptes Diagnostic quand ils cliquent
 * sur l'onglet Veille Proactive (cadenas).
 *
 * Charte Cabinet stricte : bordeaux #8B0028 + ivoire #FBF8F3 + Playfair Display
 * pour le titre. Vouvoiement D+, aucun emoji.
 */
export function VeilleProactiveUpsellModal({ open, onClose }) {
  const navigate = useNavigate();

  const features = [
    { icon: AlertCircle, label: "Alertes ruptures personnalisées sur vos références habituelles" },
    { icon: Activity, label: "Épidémiologie locale et indicateurs composites par région" },
    { icon: Sparkles, label: "Forecast saisonnier 7 jours par catégorie thérapeutique" },
    { icon: Radio, label: "Signaux faibles et tendances territoriales" },
  ];

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-xl bg-cabinet-cream border-cabinet-mute-2/40 p-0 overflow-hidden"
        data-testid="veille-proactive-upsell-modal"
      >
        {/* En-tête bordeaux/ivoire */}
        <div className="bg-cabinet-bordeaux text-cabinet-cream px-8 py-7">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-full bg-cabinet-cream/10 flex items-center justify-center flex-shrink-0">
              <Crown size={22} className="text-cabinet-gold" strokeWidth={1.5} />
            </div>
            <div>
              <DialogHeader>
                <DialogTitle
                  className="font-playfair text-2xl font-medium leading-tight tracking-tight"
                  data-testid="upsell-title"
                >
                  Veille Proactive
                </DialogTitle>
              </DialogHeader>
              <p className="text-sm text-cabinet-cream/80 mt-1 font-light tracking-wide">
                Incluse dans Pilotage et Premium
              </p>
            </div>
          </div>
        </div>

        {/* Corps */}
        <div className="px-8 py-7 space-y-6">
          <p className="text-cabinet-ink text-[15px] leading-relaxed">
            Cette couche d'intelligence stratégique signée Cabinet Benchory croise
            sept sources publiques officielles avec votre activité réelle pour
            vous offrir une longueur d'avance sur vos commandes, votre stock et
            votre activité saisonnière.
          </p>

          <ul className="space-y-3.5">
            {features.map(({ icon: Icon, label }) => (
              <li
                key={label}
                className="flex items-start gap-3 text-cabinet-ink text-[14.5px] leading-relaxed"
              >
                <span className="mt-0.5 flex-shrink-0 w-7 h-7 rounded-full bg-cabinet-bordeaux/8 flex items-center justify-center">
                  <Icon size={14} className="text-cabinet-bordeaux" strokeWidth={1.8} />
                </span>
                <span>{label}</span>
              </li>
            ))}
          </ul>

          <div className="pt-3 border-t border-cabinet-mute-2/40 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
            <p className="text-xs text-cabinet-mute-1 tracking-wide">
              Forfait Pilotage à partir de 179 € / mois
            </p>
            <button
              onClick={() => {
                onClose();
                navigate("/tarifs");
              }}
              className="px-5 py-2.5 bg-cabinet-bordeaux text-cabinet-cream rounded-md text-sm font-medium tracking-wide hover:bg-cabinet-bordeaux-soft transition-colors"
              data-testid="upsell-discover-btn"
            >
              Découvrir Pilotage et Premium
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
